var borders_default = {
  "borderT": "z4EJE",
  "borderB": "iKzd-",
  "borderL": "pztB5",
  "borderR": "hb-yD",
  "borderColorOverride": "rf5cI"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
